export const selectRetailers = state => state.retailers.list

export const selectRetailer = retailerId => state => state.retailers?.list?.[retailerId] || {}

export const selectRetailerLogo = retailerId => state => state.retailers?.assets?.[retailerId]?.logo

export const selectRetailerPin = retailerId => state => state.retailers?.assets?.[retailerId]?.pin
